import { Component, OnInit } from '@angular/core';
import { ApiServicesService } from "../../../services/api-services.service";
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LibViewPayslipComponent } from "lib-view-payslip";
import { environment } from "environment-configurations";

@Component({
  selector: 'app-my-payslips',
  templateUrl: './my-payslips.component.html',
  styleUrls: ['./my-payslips.component.scss'],
  providers: [DialogService]
})
export class MyPayslipsComponent implements OnInit {
  ref: DynamicDialogRef | undefined;
  observableSubscription$ = new Subject();
  payload = {};
  getYears: any[] = [];
  getMonths: any[] = [];
  selectedYear: string = "";
  selectedMonth: string = "";
  getPayslipDetails: any[] = [];
  getBreakupDetails: any[] = [];
  private subscription: Subscription[] = [];

  constructor(private apiService: ApiServicesService, public dialogService: DialogService
  ) { }

  ngOnInit(): void {
    this.getYearsList();
    this.getMonthsList();
  }
  getYearsList() {
    this.subscription[this.subscription.length] = this.apiService.getYearsDataSourceList("FBYEAR").pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      this.getYears = response || [];

    });
  }
  getMonthsList() {
    this.subscription[this.subscription.length] = this.apiService.getYearsDataSourceList("FBMONTHNAME").pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      this.getMonths = response || [];
    });
  }
  onChangeDuration(value, param) {
    if (param == "month") this.selectedMonth = value.value;
    else this.selectedYear = value.value;
    this.payload = {};
    this.payload["employeeId"] = sessionStorage.getItem("employeeId");
    if ((this.selectedYear !== "" && this.selectedMonth !== "") && (this.selectedYear && this.selectedMonth)) {
      this.payload["endDate"] = this.selectedMonth + "/31/" + this.selectedYear;
      this.payload["startDate"] = this.selectedMonth + "/01/" + this.selectedYear;
      this.subscription[this.subscription.length] = this.apiService.getPayslipDetails(this.payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
        this.getPayslipDetails = response.data || [];
        this.getPayslipData();
      });
    }
  }
  view() {
    if (this.getBreakupDetails) {
      this.ref = this.dialogService.open(LibViewPayslipComponent, {
        data: {
          data: this.getBreakupDetails[0]
        },
        header: 'Payslip - ' + this.getBreakupDetails[0].monthYear,
        width: '60vw',
      });
    }
  }
  getPayslipData() {
    this.getBreakupDetails = [];
    this.subscription[this.subscription.length] = this.apiService.getSalaryBreakupDetails(this.payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
      this.getBreakupDetails.push(response.data || []);
    });
  }
  download() {
    if (this.getBreakupDetails) {
      this.subscription[this.subscription.length] = this.apiService.getPayslipDownloadDetails(this.payload).pipe(takeUntil(this.observableSubscription$)).subscribe((response: any) => {
        if (response.data) {
          const path = environment.docs + response.data.replace('/var/imagility/uploads/', '');
          this.apiService.downloadDocuments(path, "Payslip - " + this.getBreakupDetails[0].monthYear);
        }
      });
    }

  }
  ngOnDestroy(): void {
    this.observableSubscription$.next();
    this.observableSubscription$.complete();
    this.subscription.forEach(sub => sub.unsubscribe());
  }
}
